import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

if (typeof window !== "undefined") {
  ((c, l, a, r, i, t, y) => {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y?.parentNode?.insertBefore(t, y);
  })(
    window as Window & {
      clarity?: { q?: unknown[] };
      [key: string]: unknown;
    },
    document,
    "clarity",
    "script",
    "py77uz98wq"
  );
}

createRoot(document.getElementById("root")!).render(<App />);
